<template>
  <div class="program-detail-column" data-testid="program-detail-column">
    <div class="program-image">
      <img v-if="imageUrl" :src="imageUrl" alt="" />
      <img v-else src="@/assets/placeholder_image.png" alt="" />
    </div>

    <v-card class="info-card" flat>
      <div class="info-card__row">
        <Icon icon="mdi-calendar-blank" color="darkGrey" />
        <Typography variant="body-1" as="span">{{ dateRangeLabel }}</Typography>
      </div>
    </v-card>

    <v-card v-if="showProgressCard" class="info-card progress-card" flat>
      <Typography variant="h-5" as="p">Your Progress</Typography>
      <div v-if="metricsLoading" class="progress-card__loading">
        <v-progress-circular
          indeterminate
          color="primary"
          :size="40"
          :width="4"
          aria-label="Loading progress"
        />
      </div>
      <template v-else>
        <SummaryMetricRows
          :rows="metricRows"
          :is-dollar-budget="isDollarBudget"
          :basis="basis"
          :metrics-missing="metricsMissing"
          :load-failed="metricsLoadFailed"
        />
      </template>
    </v-card>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Icon from "@/components/generic/Icon.vue";
import SummaryMetricRows from "./SummaryMetricRows.vue";

export default {
  name: "ProgramDetailColumn",
  components: { Typography, Icon, SummaryMetricRows },
  props: {
    imageUrl: { type: String, default: null },
    dateRangeLabel: { type: String, default: "" },
    // [{ key, columns: [{ key, componentType, metric }] }] with metric values
    // already resolved. A column with a null componentType renders as an empty
    // spacer. Empty metricRows show the heading only.
    metricRows: { type: Array, default: () => [] },
    isDollarBudget: { type: Boolean, default: false },
    basis: { type: String, default: null },
    metricsLoading: { type: Boolean, default: false },
    metricsMissing: { type: Boolean, default: false },
    status: { type: String, default: null },
    metricsLoadFailed: { type: Boolean, default: false },
  },
  computed: {
    showProgressCard() {
      return this.status !== "Scheduled";
    },
  },
};
</script>

<style scoped>
/* Fluid by design — consumers own the column's width and placement. */
.program-detail-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  text-align: left;
}

.program-image {
  width: 100%;
  aspect-ratio: 362 / 176;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15);
}

.program-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.info-card {
  background: white !important;
  border-radius: 8px !important;
  padding: 16px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3), 0px 2px 3px rgba(0, 0, 0, 0.15) !important;
}

.info-card__row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.progress-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.progress-card__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
}
</style>
